export default __webpack_public_path__ + "static/media/blueLogo.10abe035.webp";